import React, { FC } from 'react';

import { GiftItemInfoType } from '@shared/api/giftItemInfo/giftItemInfo.interface';
import { formatPrice } from '@shared/utils/formatPrice';

interface IProps {
  image: string;
  name: string;
  priceRegular: number;
  priceRetail: number;
  type: GiftItemInfoType;
  tags?: string[];
}

const GiftItemPreview: FC<IProps> = ({
  image,
  name,
  priceRegular,
  priceRetail,
  type,
  tags,
}: IProps) => {
  const discountRate =
    priceRegular > 0
      ? Math.round(((priceRegular - priceRetail) / priceRegular) * 100)
      : 0;

  return (
    <div className="relative flex flex-col overflow-hidden rounded-lg text-base leading-5 shadow-sm theme-bg-1">
      {/* 상품 사진 */}
      <div className="relative">
        <img
          src={image}
          alt={name}
          className="aspect-square w-full object-cover object-center"
        />
        {/* 타입 뱃지 */}
        <div
          className={`absolute left-0 top-0 px-2 py-1 text-sm font-bold text-white ${
            type === GiftItemInfoType.Delivery ? 'bg-blue-500' : 'bg-purple-500'
          }`}
        >
          {type === GiftItemInfoType.Delivery ? '배송' : '선택형 쿠폰'}
        </div>
      </div>
      {/* 상품 정보 */}
      <div className="flex flex-col px-2 py-2">
        {/* 상품명 */}
        <h4 className="truncate pt-1 text-base font-bold">{name}</h4>
        {/* 상품 가격 */}
        <div className="flex items-center justify-between pt-1">
          {/* 할인율 */}
          {discountRate > 0 ? (
            <div className="flex items-center text-lg text-[#00A3B0]">
              <div className="font-bold">{discountRate}</div>
              <span className="text-xs">%↓</span>
            </div>
          ) : (
            <div></div>
          )}
          {/* 상품 가격 */}
          <div className="flex items-end justify-end space-x-1">
            {/* 원래 가격 */}
            {priceRetail !== priceRegular && priceRegular > 0 && (
              <div className="text-xs leading-4 line-through theme-text-8">
                {formatPrice(priceRegular)}원
              </div>
            )}
            {/* 할인 적용 가격 */}
            <div className="flex items-end">
              <h3 className="text-lg font-bold">{formatPrice(priceRetail)}</h3>
              <span className="text-sm">원</span>
            </div>
          </div>
        </div>
        {/* 태그 */}
        {tags && tags.length > 0 && (
          <div className="mt-1.5 flex flex-wrap gap-1">
            {tags.slice(0, 2).map((tag, i) => (
              <span
                key={`${tag}-${i}`}
                className="rounded bg-gray-100 px-2 py-0.5 text-xs text-gray-600"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(GiftItemPreview);
